import * as React from 'react';
import { observer } from 'mobx-react';
import LearningCollectionEditStore from '../../../../Store';
import { ProductLicenseResource } from '../../../../../../Types';
import { emptyFragment } from '../../../../../../../../EmptyFragment';
import { warnUser } from './Selection';
import { AlreadyTranslated, T } from '../../../../../../../../Translations';
import ModalStore from '../../../../../../../Modal/Store';
import { CustomizeState } from '../../../../Store/Types';
import {
  productLicenseCardStyle,
  checkedStatus,
} from '../../../../../CurrentCollectionStep/ChooseProductLicense/Left/ActiveProductLicense/Selection';

interface Props {
  store: LearningCollectionEditStore;
  modalStore: ModalStore;
  state: CustomizeState;
  activeProductLicense: ProductLicenseResource;
  updateProductLicense: (productLicense: ProductLicenseResource) => void;
  dataIntercomTarget?: string;
}

function ActiveProductLicense({
  store,
  activeProductLicense,
  modalStore,
  updateProductLicense,
  state,
  dataIntercomTarget,
}: Props) {
  const updateProductLicenseAndOpenModal = () => {
    updateProductLicense(activeProductLicense);
    modalStore.open();
  };

  const handleSelect = () => {
    warnUser(state, activeProductLicense)
      .do(() => updateProductLicenseAndOpenModal())
      .elseDo(() => store.selectProductLicense(activeProductLicense.payload.id));
  };

  const handleChildClick = (e: React.MouseEvent<HTMLInputElement>) => {
    e.stopPropagation();
    handleSelect();
  };

  return (
    <div
      className="drop-shadow"
      key={activeProductLicense.payload.id}
      onClick={handleSelect}
      data-intercom-target={dataIntercomTarget}
    >
      <label
        className={productLicenseCardStyle(store.selectedProductLicense, activeProductLicense)}
      >
        <input
          type="radio"
          name="selectedLearningDesign"
          value={activeProductLicense.payload.id}
          className="mt-1 inline-block h-5 w-5 text-teal-600"
          checked={checkedStatus(store.selectedProductLicense, activeProductLicense)}
          onClick={handleChildClick}
          readOnly
        />
        <div className="ml-4 w-full">
          <div>
            <h3 className="text-sm font-medium">
              {activeProductLicense.payload.licenseTypePublicName
                .map((licenseTypePublicName) => (
                  <AlreadyTranslated content={licenseTypePublicName} />
                ))
                .getOrElse(emptyFragment)}
            </h3>
            <div className="flex">
              <p className="pt-2.5 text-sm">
                <T
                  kind="{{count}} License Available"
                  count={activeProductLicense.payload.licenseQuantity}
                />
              </p>
            </div>
          </div>
        </div>
      </label>
    </div>
  );
}

export default observer(ActiveProductLicense);
